import styled from "styled-components";

export const Background = styled.div`
    height: 100%;
    width: 100%;
`;
